<template>
  <div class="card h-100">
    <img v-if="product.get('images') && product.get('images').length > 0" :src="$imgUrl(product.get('images')[0])" class="card-img-top">
    <div class="card-body d-flex flex-column px-2 py-3">
      <router-link class="product-name" :to="`/productDetail/${product.id}`">
        <p>{{product.get('name')}}</p>
      </router-link>
      <div class="d-flex justify-content-between align-items-end mt-auto">
        <div class="d-flex align-items-center">
          <div v-if="product.get('price')">
            <div v-if="!product.get('subProducts')">
              <span class="product-price">฿{{eArabic(product.get('price'))}}</span>
              <span class="product-unit"> /{{product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</span>
            </div>
            <div v-else>
              <span class="product-price">฿{{ eArabic(Math.min(...product.get('subProducts').map(d => d.get('price')))) }} - ฿{{ eArabic(Math.max(...product.get('subProducts').map(d => d.get('price')))) }}</span>
              <span class="product-unit"> /{{product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</span>
            </div>
          </div>
        </div>
        <div>
          <button 
            v-if="product.get('price') && !product.get('isSoldOut')" 
            class="btn btn-primary btn-action"
             @click="addCart(product)"
          >
            <i class="fas fa-shopping-cart"></i>
            สั่งซื้อ
          </button>
          <router-link v-else :to="`/productDetail/${product.id}`">
            <button class="btn btn-action btn-detail">ดูรายละเอียด</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import store from "../store"
export default {
  name: 'ProductItem',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    eArabic(x, num = 0) {
      if (x)
        return x.toLocaleString(undefined, {
          minimumFractionDigits: num,
          maximumFractionDigits: num
        });
      else return num == 2 ? "0.00" : "0";
    },
    async addCart(product){
      let objCart = {
        productId: product.id,
        number: 1
      }

      if(localStorage.getItem('carts')){
        if(JSON.parse(localStorage.getItem('carts')).findIndex(item => item.productId === product.id) <= -1){
          let carts = JSON.parse(localStorage.getItem('carts'))
          let balanceStore = await this.Parse.Cloud.run("MarketProduct_countBalanceStore",{productId : product.id});

          carts.push(objCart)

          localStorage.setItem('carts',JSON.stringify(carts))
          store.commit('setCarts', carts)
          store.commit('addHashBalanceProduct', balanceStore)
        }
      }else{
        localStorage.setItem('carts',JSON.stringify([objCart]))
        store.commit('setCarts', [objCart])
      }
      $("#addCartToast").addClass('show')
      $("#addCartToast").removeClass('hide')

      setTimeout(function(){
        $("#addCartToast").removeClass('show')
        $("#addCartToast").addClass('hide')
      },2000)
    }
  }
}
</script>

<style scoped>
.product-name {
  font-size: 18px;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 2.8em;
  text-decoration: none;
  color: #000;
}
.product-price {
  font-size: 18px;
  font-weight: 500;
}
.product-unit {
  font-size: 16px;
  font-weight: 500;
}
.card-img-top {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
}
img {
  width: 100%;
  height: auto;
}
.btn-action {
  border-radius: 50px;
  padding: 6px 16px;
  font-size: 14px;
  white-space: nowrap;
}
.btn-detail {
  background: #fff;
  color: var(--secondary);
  border: 1px solid var(--light);
}
.btn-detail:hover {
  background: #f5f5f5;
  color: var(--secondary);
}
</style>
